import Daftar from './../views/registration/Daftar.vue'
import Aktivasi from './../views/registration/Aktivasi.vue'

const registration = [
  {
    path: '/registrasi', 
    component: Daftar
  },
  {
    path: '/registrasi/user/:kodeUrl',
    component: Aktivasi
  }
]

export default registration